// services/consultar_cliente.js
export const consultarCliente = async(requestBody) => {
    try {
        // Configuración de la API - actualiza la URL según sea necesario
        const API_URL = 'https://hosting-visioner7.com/api/v1_apibbva/consultacliente.php';

        const token = localStorage.getItem('auth_token');

        if (!token) {
            return {
                success: false,
                error: 'No hay sesión activa'
            };
        }

        const response = await fetch(API_URL, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': 'application/json'
            },
            mode: 'cors',
            body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
            throw new Error(`Error en la petición: ${response.status}`);
        }

        const data = await response.json();

        // Verificar si la API devuelve un error
        if (!data.success) {
            throw new Error(data.message || 'Error en la consulta');
        }

        return data;
    } catch (error) {
        console.error('Error en consultarCliente:', error);
        throw error;
    }
};